import * as React from "react";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { Button, DeleteMenuItem } from "components/bootstrap";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
const RetrievalArchiveAction = ({ onClick, buttonType = "menu" }) => {
  const sendTelemetry = useSendTelemetry();
  const onOpenDeleteConfirm = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.DATALAKE.DATA_DELETION_OPENED, {});
    onClick();
  };
  const isMenuButton = buttonType === "menu";
  const ItemComponent = isMenuButton ? DeleteMenuItem : Button;
  const buttonProps = isMenuButton ? {} : { bsStyle: "danger" };
  return /* @__PURE__ */ React.createElement(ItemComponent, { onClick: onOpenDeleteConfirm, bsSize: "xsmall", ...buttonProps }, "Delete");
};
export default RetrievalArchiveAction;
